// extracted by mini-css-extract-plugin
module.exports = {"unlinkButton":"UnlinkTwitchButton_unlinkButton__jZFRc","confirmation":"UnlinkTwitchButton_confirmation__la1J2","air":"UnlinkTwitchButton_air__U3N0O"};